export { loadJsonFile };

import axios from 'axios';

function loadJsonFile(jsonFileName, label) {
  return new Promise((resolve, reject) => {
    axios
      .get(jsonFileName)
      .then(
        resp => {
          resolve(resp);
        },
        err => {
          const errormsg = 'Error during ' + label + ' json loading';
          console.log(errormsg);
          console.log(err);
          reject(err);
        }
      )
      .catch(err => {
        const errormsg = 'Error during ' + label + ' json loading';
        console.log(errormsg);
        console.log(err);
      });
  });
}
